import CDNImage from '@/components/ui/CDNImage';
import { Page_Pagebuilder_Blocks_Logotypes } from '@/graphql/generated/graphql';
import { getContainerClass } from 'utils/helpers';
import Wysiwyg from '../components/dom-parser';

const LogotypesBlock = ({
  blockId,
  gallery,
  title,
  containerWidth,
}: Page_Pagebuilder_Blocks_Logotypes) => {
  if (!gallery || gallery.length === 0) return null;
  return (
    <section id={blockId ?? undefined} className="w-full my-14 lg:my-24">
      <div className={`w-full ${getContainerClass(containerWidth)}`}>
        {title && <h2 className="mb-8 md:mb-10 text-center">{title}</h2>}
        <div className="flex flex-wrap justify-center gap-x-4 md:gap-x-8 gap-y-6 md:gap-y-8 px-4 md:px-0">
          {gallery.map((image, index) => (
            <div
              key={index}
              className="grid justify-center gap-3 md:gap-4 w-[104px] md:w-32"
            >
              <CDNImage
                width={100}
                height={100}
                src={image.sourceUrl}
                alt={image.altText}
                className="w-[90px] md:w-[100px] h-[90px] md:h-[100px] shrink-0 object-contain"
              />
              {image.altText && (
                <div className="font-light text-xs md:text-sm text-center text-neutral-600">
                  <Wysiwyg>{image.altText}</Wysiwyg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogotypesBlock;
